import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Voucher } from 'app/models/vouchers/voucher';
import { VoucherApplication } from 'app/models/vouchers/voucher-application';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'attach-letter',
  templateUrl: './attach-letter.component.html',
  styleUrls: ['./attach-letter.component.scss']
})
export class AttachLetterComponent implements  OnInit {
  voucher: Voucher = undefined;
  voucherApplication: VoucherApplication = undefined;
  processing: boolean = false;
  processingMessage: string = "";
  attachment: VoucherLetterUpload = undefined;
  filename: string = '';
  files: File[] = [];



  constructor(@Inject(MAT_DIALOG_DATA) public data: VoucherLetterUpload,
              public voucherService: VoucherService, 
              private toastr: ToastrService, 
              private dialogRef: MatDialogRef<AttachLetterComponent>,
              public oregonWellDataService: OregonWellDataService) {                
                this.attachment = data;
  }


  ngOnInit(): void {
    this.load();
  }

  load() {
    if(this.attachment.voucherId > 0) {
      this.loadVoucher();
    }
    else {
      this.loadVoucherApplication();
    }
  }

  loadVoucher() {
    this.processing = true;
    this.processingMessage = "Loading";
    this.voucherService.getVoucherById(this.attachment.voucherId).subscribe(
      result => {
        this.voucher = result;
        this.processing = false;
        this.processingMessage = "";
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  loadVoucherApplication() {
    this.processing = true;
    this.processingMessage = "Loading";
    this.voucherService.getVoucherApplicationById(this.attachment.voucherApplicationId).subscribe(
      result => {
        this.voucherApplication = result;
        this.processing = false;
        this.processingMessage = "";
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  onFileSelected(event: Event): void {
    this.files = [];
    let newFiles: File[] = Array.from((event.target as HTMLInputElement).files);
    newFiles.forEach((file) => {
      this.files.push(file);
      this.filename = file.name;
    });
    (event.target as HTMLInputElement).value = '';
  }

  removeStagedFile() {
    this.files = [];
    this.filename = "";
  }

  uploadFile() {   
    console.log("uploadFile");
    this.processingMessage = "Uploading";
    this.processing=true;
    const formData = new FormData();
    
    formData.append("file", this.files[0], this.filename);
    formData.append("letter", JSON.stringify(this.attachment));
    
    this.voucherService.attachLetter(formData).subscribe(
      result => {
        this.processingMessage = "";
        this.processing = false;
        this.toastr.success("Letter attached!");
        this.dialogRef.close();
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

 
}